<template>
  <ValidationObserver ref="loginForm" slim>
    <b-form @submit.prevent="login">
      <b-card no-body>
        <b-card-header>
          <div class="text-primary d-flex justify-content-between align-items-center">
            <h4>Interra Travel</h4>
            <span><img src="@/assets/images/logo-interra-2.svg" alt="logo interra" class="img-fluid logo-img"></span></div>
        </b-card-header>
        <b-card-body>
          <ValidationProvider
              name="Agency code"
              :rules="{ required: true }"
              v-slot="vContext"
            >
            <b-form-group>
              <b-input
                type="text"
                name="Agency code"
                id="agency"
                v-model="credentials.client"
                :placeholder="$gettext('Agency code:')"
                :state="getValidationState(vContext)"
                size="sm"
                aria-describedby="agency"/>
                <b-form-invalid-feedback id="agency">{{ vContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
          <ValidationProvider
            name="User name"
            :rules="{required: true}"
            v-slot="vContext"
          >
            <b-form-group>
              <b-input
                type="text"
                name="numeAgent"
                id="numeAgent"
                v-model="credentials.username"
                :placeholder="$gettext('User name:')"
                size="sm"
                :state="getValidationState(vContext)"
                aria-describedby="agentName" />
              <b-form-invalid-feedback id="agentName">{{ vContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
          <ValidationProvider
            name="Parola"
            :rules="{required: true}"
            v-slot="vContext"
          >
            <b-form-group>
              <b-input
                type="password"
                name="password"
                id="password"
                v-model="credentials.password"
                :placeholder="$gettext('Password:')"
                size="sm"
                :state="getValidationState(vContext)"
                aria-describedby="password" />
              <b-form-invalid-feedback id="password">{{ vContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
        </b-card-body>
        <b-card-footer class="d-flex justify-content-between align-items-center">
          <div>
            <small class="text-center py-1">Pentru a solicita user si parola <router-link :to="{ name: 'Public/Subscribe' }" class="link">click aici</router-link> </small>
          </div>
          <b-button type="submit" variant="primary" size="sm"> <b-icon icon="box-arrow-in-right" font-scale=".9" class="mr-2"/><translate>Autentification</translate></b-button>
        </b-card-footer>
      </b-card>
    </b-form>
  </ValidationObserver>
</template>

<script>
import validation from 'b2b-common/mixins/validation'
import toast from 'b2b-common/mixins/toast'

export default {
  name: 'Login',
  mixins: [validation, toast],
  data () {
    return {
      credentials: {
        client: '',
        username: '',
        password: ''
      }
    }
  },
  methods: {
    login () {
      this.$refs.loginForm.validate().then(success => {
        if (!success) {
          this.addToast({
            title: this.$gettext('Invalid form'),
            message: this.$gettext('Please fill in all required fields!'),
            variant: 'danger'
          })
        } else {
          this.$emit('login', this.credentials)
        }
      })
    }
  }
}
</script>

<style lang="scss">

</style>
